<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="6">
        <!-- Основная информация -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2">
          <v-card-title>Основная информация</v-card-title>
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="ID пользователя на сайте"
                :placeholder="$route.params.id"
                v-model="site_id"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Полное имя"
                :placeholder="SELECTED_ACTOR.full_name"
                :value="SELECTED_ACTOR.full_name"
                v-model="full_name"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Имя на сайте (rus):"
                :placeholder="SELECTED_ACTOR.ru_name"
                v-model="ru_name"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Имя на сайте (eng):"
                :placeholder="SELECTED_ACTOR.eng_name"
                v-model="eng_name"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Пол"
                :placeholder="SELECTED_ACTOR.gender === 'M' ? 'Male' : 'Female'"
                outlined
                v-model="gender"
                :items="genderOpt"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Статус"
                :placeholder="SELECTED_ACTOR.status"
                v-model="status"
                outlined
                :items="statusOpt"
              ></v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Фотография -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2" min-height="520">
          <v-card-title>Фото:</v-card-title>
          <v-row>
            <v-col cols="4">
              <v-btn
                color="primary"
                @click="isEditPhoto = true"
                class="mr-4 mb-5"
                ><clipper-upload v-model="imageSrc"
                  >Загрузить</clipper-upload
                ></v-btn
              >
              <v-btn @click="getResult">Применить</v-btn>
            </v-col>
            <v-col cols="7">
              <clipper-basic
                v-if="isEditPhoto"
                class="my-clipper"
                ref="clipper"
                :src="imageSrc"
                preview="my-preview"
                :ratio="260/330"
              >
                <div class="placeholder" slot="placeholder">No image</div>
              </clipper-basic>
              <v-img
                :src="imageSrc === '' ? 'https://rocky-beyond-96534.herokuapp.com' + SELECTED_ACTOR.photo : imageSrc"
                v-if="!isEditPhoto"
                max-width="400"
              ></v-img>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <!-- Аудио -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2">
          <v-card-title>Аудиофайл:</v-card-title>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-btn
                color="primary"
                class="mt-3"
                @click="$refs.uploadAudio.click()"
                >Загрузить</v-btn
              >
              <input
                type="file"
                ref="uploadAudio"
                v-show="false"
                @change="previewThumbnail"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field v-model="audioName"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <audio controls :src="audioSrc === '' ? 'https://rocky-beyond-96534.herokuapp.com' + SELECTED_ACTOR.voice_file : audioSrc"></audio>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Языковая информация -->
        <v-card class="pl-12 pr-12 pt-2 pb-10 mt-2 mb-2">
          <v-card-title>Языковая информация:</v-card-title>
          <v-row>
            <v-col cols="6" >
              <v-select
                label="Язык ISO 639-2"
                outlined
                :items="LANGUAGE"
                v-if="SELECTED_ACTOR.language"
                :placeholder="SELECTED_ACTOR.language.language"
                v-model="language"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Диалект"
                outlined
                :items="DIALECT"
                v-if="SELECTED_ACTOR.dialect"
                :placeholder="SELECTED_ACTOR.dialect.dialect"
                v-model="dialect"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Страна"
                outlined
                :items="COUNTRY"
                v-if="SELECTED_ACTOR.country"
                :placeholder="SELECTED_ACTOR.country.country"
                v-model="country"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Город"
                :placeholder="SELECTED_ACTOR.city"
                v-model="city"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Флаг"
                outlined
                :items="flags"
                v-if="SELECTED_ACTOR.country"
                :placeholder="SELECTED_ACTOR.country.country"
                v-model="flag"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-img v-if="SELECTED_ACTOR.flag" :src="'https://rocky-beyond-96534.herokuapp.com' + SELECTED_ACTOR.flag.flag" width="300"></v-img>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Биография -->
        <v-card class="pl-12 pr-12 pt-2 mt-2 mb-2" min-height="440">
          <v-card-title>Биография:</v-card-title>
          <v-row>
            <v-col cols="12" class="mt-n4">
              <v-textarea
                label="Биография (rus)"
                outlined
                :placeholder="SELECTED_ACTOR.bio_ru"
                v-model="bio_ru"
              ></v-textarea>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-textarea
                label="Биография (eng)"
                outlined
                :placeholder="SELECTED_ACTOR.bio_eng"
                v-model="bio_eng"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Портфолио -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2">
          <v-card-title>Портфолио:</v-card-title>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Upwork"
                outlined
                :placeholder="SELECTED_ACTOR.upwork_url"
                v-model="upwork_url"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Fiverr"
                outlined
                :placeholder="SELECTED_ACTOR.fiverr_url"
                v-model="fiverr_url"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Дополнительный ресурс 1"
                :placeholder="SELECTED_ACTOR.extra_url_1"
                v-model="extra_url_1"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Дополнительный ресурс 2"
                :placeholder="SELECTED_ACTOR.extra_url_2"
                v-model="extra_url_2"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Контакты -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2">

          <v-card-title>Контакты:</v-card-title>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="E-mail"
                :placeholder="SELECTED_ACTOR.email"

                v-model="email"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Skype"
                outlined
                :placeholder="SELECTED_ACTOR.skype"
                v-model="skype"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Телефон"
                outlined
                :placeholder="SELECTED_ACTOR.phone"
                type="number"
                v-model="phone"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Прочие контакты"
                outlined
                :placeholder="SELECTED_ACTOR.extra_contact"
                v-model="extra_contact"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Оплата -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2">
          <v-card-title>Оплата:</v-card-title>
          <v-row>
            <v-col cols="6">
              <v-select label="Валюта" outlined v-if="SELECTED_ACTOR.currency" v-model="currency" :items="CURRENCY" :placeholder="SELECTED_ACTOR.currency.currency"></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Ставка" outlined :placeholder="String(SELECTED_ACTOR.price)" v-model="price"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Почта PayPal" outlined :placeholder="SELECTED_ACTOR.paypal_email" v-model="paypal_email"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Прочее (оплата)" outlined :placeholder="SELECTED_ACTOR.extra_price" v-model="extra_price"></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <!-- Заметки -->
        <v-card class="pl-12 pr-12 pt-2 pb-2 mt-2 mb-2" min-height="300">
          <v-card-title>Заметки:</v-card-title>
          <v-row>
            <v-col cols="12">
              <v-textarea label="Заметки" outlined v-model="notes" :placeholder="SELECTED_ACTOR.notes"></v-textarea>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-row justify="center">
        <v-btn color="primary" class="ml-n2" @click="saveEdit">Сохранить</v-btn>
        <v-btn color="error" class="ml-6" @click="$router.push('/')">Отменить</v-btn>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      statusOpt: ["On", "Off"],
      genderOpt: [
        { text: "Male", value: "M" },
        { text: "Female", value: "F" },
      ],
      imageSrc:
        "",
      audioSrc: "",
      isEditPhoto: false,
      isPlayingAudio: false,
      audioName: "",
      site_id: "",
      full_name: "",
      ru_name: "",
      eng_name: "",
      status: "",
      gender: "",
      photo: "",
      photo_thumbnail: "",
      language: "",
      dialect: "",
      country: "",
      city: "",
      flag: "",
      voice_file: "",
      bio_ru: "",
      bio_eng: "",
      upwork_url: "",
      fiverr_url: "",
      extra_url_1: "",
      extra_url_2: "",
      email: "",
      skype: "",
      phone: "",
      extra_contact: "",
      currency: "",
      price: "",
      paypal_email: "",
      extra_price: "",
      notes: "",
    };
  },
  methods: {
    ...mapActions(["GET_SELECTED_ACTOR","SAVE_EDIT"]),
    getResult() {
      const canvas = this.$refs.clipper.clip();
      this.imageSrc = canvas.toDataURL("image/jpeg", 1);
      this.isEditPhoto = false;
    },
    previewThumbnail: function (event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        this.audioName = input.files[0].name;
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          vm.audioSrc = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    playAudio() {
      if (this.isPlayingAudio == false) {
        var snd = new Audio(this.audioSrc);
        snd.play();
        this.isPlayingAudio = true;
      } else {
        snd.pause();
      }
    },
    saveEdit() {
      let actor = {
        site_id: this.site_id === "" ? this.SELECTED_ACTOR.site_id : this.site_id,
        full_name: this.full_name === "" ? this.SELECTED_ACTOR.full_name : this.full_name,
        ru_name: this.ru_name === "" ? this.SELECTED_ACTOR.ru_name : this.ru_name,
        eng_name: this.eng_name === "" ? this.SELECTED_ACTOR.eng_name : this.eng_name,
        status: this.status === "" ? this.SELECTED_ACTOR.status : this.status,
        gender: this.gender === "" ? this.SELECTED_ACTOR.gender : this.gender,
        photo: this.photo,
        language: this.language === "" ? {language: this.SELECTED_ACTOR.language.language} : {language: this.language},
        dialect: this.dialect === "" ? {dialect: this.SELECTED_ACTOR.dialect.dialect} : {dialect: this.dialect},
        country: this.country === "" ? {country: this.SELECTED_ACTOR.country.country} : {country: this.country},
        city: this.city === "" ? this.SELECTED_ACTOR.city : this.city,
        flag: this.flag === "" ? {flag: this.SELECTED_ACTOR.flag.flag} : {flag: this.flag},
        voice_file: this.audioSrc === "" ? this.SELECTED_ACTOR.voice_file : this.audioSrc,
        bio_ru: this.bio_ru === "" ? this.SELECTED_ACTOR.bio_ru : this.bio_ru,
        bio_eng: this.bio_eng === "" ? this.SELECTED_ACTOR.bio_eng : this.bio_eng,
        upwork_url: this.upwork_url === "" ? this.SELECTED_ACTOR.upwork_url : this.upwork_url,
        fiverr_url: this.fiverr_url === "" ? this.SELECTED_ACTOR.fiverr_url : this.fiverr_url,
        extra_url_1: this.extra_url_1 === "" ? this.SELECTED_ACTOR.extra_url_1 : this.extra_url_1,
        extra_url_2: this.extra_url_2 === "" ? this.SELECTED_ACTOR.extra_url_2 : this.extra_url_2,
        email: this.email === "" ? this.SELECTED_ACTOR.email : this.email,
        skype: this.skype === "" ? this.SELECTED_ACTOR.skype : this.skype,
        phone: this.phone === "" ? this.SELECTED_ACTOR.phone : this.phone,
        extra_contact: this.extra_contact === "" ? this.SELECTED_ACTOR.extra_contact : this.extra_contact,
        currency: this.currency === "" ? {currency: this.SELECTED_ACTOR.currency.currency} : {currency: this.currency},
        price: this.price === "" ? this.SELECTED_ACTOR.price : this.price,
        paypal_email: this.paypal_email === "" ? this.SELECTED_ACTOR.paypal_email : this.paypal_email,
        extra_price: this.extra_price === "" ? this.SELECTED_ACTOR.extra_price : this.extra_price,
        notes: this.notes === "" ? this.SELECTED_ACTOR.notes : this.notes,
      }
      this.SAVE_EDIT(actor);
    }
  },
   computed: {
    ...mapGetters([
      "LANGUAGE",
      "DIALECT",
      "COUNTRY",
      "CURRENCY",
      "SELECTED_ACTOR",
    ]),
  },
  created() {
    this.GET_SELECTED_ACTOR(this.$route.params.id);
    this.$store.dispatch("GET_FILLERS");
  },

};
</script>

<style></style>
